module.exports = __webpack_public_path__ + "assets/img/20.ae08b611.png";